<template>
  <div class="w-full pt-2 flex flex-col divide-y text-center">
    <div class="flex items-center gap-2 cursor-pointer mb-3 pb-3" @click="emit('back')">
      <ArrowLeft class="h-5 w-5" />
      <span class="text-lg font-semibold grow text-center">Cash Payment</span>
    </div>

    <div class="py-4">
      <h1 class="text-lg font-semibold my-2 text-black">Pending Payment</h1>
      <p class="text-sm text-black mb-2">
        Your payment is pending and will be paid once you make the payment at your nearest Pay@ money counter.
      </p>
      <p class="text-lg my-2 text-brand-700 font-semibold">Pay@ Reference: {{ payAtReference }}</p>
      <p class="text-sm mb-2 text-black">
        We will be sending you an email and SMS to ensure you have the correct details to make the payment.
      </p>
      <p class="text-sm mb-2 text-black">
        Please Note: If your payment is received after the due date, your payment will be unsuccessful.
      </p>
    </div>

    <div class="flex justify-between items-center py-3">
      <p class="text-sm text-black">Due Today (Payment)</p>
      <p class="text-sm font-semibold text-black">{{ displayCurrency(props.amountCents) }}</p>
    </div>

    <div v-if="errorMessage" class="rounded-md w-full bg-red-100 px-4 py-3 text-sm text-red-700 my-2">
      {{ errorMessage }}
    </div>

    <div class="pt-3">
      <button
        class="w-full bg-teal-600 text-white font-bold py-2 rounded-lg hover:bg-teal-700 disabled:opacity-60"
        :disabled="isLoading"
        @click="handleOkay"
      >
        <span v-if="isLoading">Processing...</span>
        <span v-else>Okay</span>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { paymentPlanNotification } from '@/services/paymentPlans';
import { displayCurrency } from '@/utils/format.utils';
import { addMetric, createException } from '@/utils/monitoring.utils';
import { ArrowLeft } from 'lucide-vue-next';
import { ref } from 'vue';

const props = defineProps<{
  paymentPlanId: string;
  amountCents: number;
  payAtReference: string;
}>();

const emit = defineEmits<{
  back: [];
  done: [];
}>();

const isLoading = ref(false);
const errorMessage = ref('');

const handleOkay = async () => {
  isLoading.value = true;
  errorMessage.value = '';

  try {
    await paymentPlanNotification(props.paymentPlanId);
    addMetric('accept_payment', { status: 'success', payment_method: 'pay-at', channel: 'shopper' });

    emit('done');
  } catch (error: any) {
    createException(error);
    addMetric('accept_payment', { status: 'failure', payment_method: 'pay-at', channel: 'shopper' });
    errorMessage.value =
      error?.response?.data ||
      'Your notification could not be sent. Please note the reference manually or try again later.';
  } finally {
    isLoading.value = false;
  }
};
</script>
